






















import { Component, Prop, Vue } from 'vue-property-decorator';

import { ReportDirectory } from '@/models/report.model';

import ReportPageListItemEmpty from './ReportPageListItemEmpty.vue';
import ReportPageListItemFile from './ReportPageListItemFile.vue';
import ReportPageListItemFolder from './ReportPageListItemFolder.vue';

@Component({
  name: 'ReportPageList',
  components: {
    ReportPageListItemEmpty,
    ReportPageListItemFile,
    ReportPageListItemFolder,
  },
})
class ReportPageList extends Vue {
  @Prop() directory!: ReportDirectory[];
}

// Global declaration to allow for circular dependencies.
Vue.component('ReportPageList', ReportPageList);
export default ReportPageList;
